/**
 * Ellie Belle - Package Protection Auto-Add (US only)
 * -------------------------------------------------------------
 * CANDIDATE v5.1 (staging only). Adds the Return Label + Package Protection
 * line to US carts, recalculates it when the merchandise value changes,
 * and respects a client's decision to remove it.
 *
 * Merchandise value = cart total excluding protection lines, taken from each
 * line's original_line_price so a discount code never lowers the fee, converted
 * to USD for non-USD presentment.
 *
 * US:
 *   below $50           not offered
 *   $50 to $500         linear $6.95 to $10.95
 *   $500 to $5,000      2.0% of value + $0.95
 *   above $5,000        not offered
 *
 * International protection is discontinued for new purchases. When the
 * storefront country is not US, this script never adds protection and removes
 * any protection line it finds (without setting the decline flag, so the
 * client's own opt-out state is untouched). Historical International variant
 * ids stay recognized as protection lines so they are never priced as
 * merchandise. Existing orders are unaffected.
 *
 * Country source: window.EllieBelle.country (Markets storefront country).
 * Ship-to country is enforced separately at checkout (delivery profile).
 */
(function () {
  "use strict";

  if (window.Shopify && window.Shopify.designMode) return; // don't run in theme editor

  // PRICING_MODE is the only line that differs between the release script and the
  // rollback script. "current" = final US ladder. "previous" = the schedule that was
  // live before this change (1.5% rate, $2,667 ceiling). Both modes are US only.
  var PRICING_MODE = "current";

  var MIN_OFFER_CENTS = 5000;     // $50.00, below this no protection is offered
  var MAX_OFFER_CENTS = 500000;   // $5,000.00, above this no protection is offered

  // US ladder: $6.95 at $50, straight line to $10.95 at $500, then 2.0% + $0.95.
  var US_FLOOR_CENTS = 695;
  var US_KNEE_VALUE_CENTS = 50000;
  var US_KNEE_FEE_CENTS = 1095;
  var US_RATE = 0.02;
  var US_FIXED_CENTS = 95;

  // US: price tiers on the "(US)" product (grid in $0.50 steps to $20.95, then $1 steps).
  var DOMESTIC_TIERS = [
    {id:50808177164386,cents:645}, {id:50808177197154,cents:695}, {id:50808177229922,cents:745},
    {id:50808177262690,cents:795}, {id:50808177295458,cents:845}, {id:50808177328226,cents:895}, {id:50808177360994,cents:945},
    {id:50808177393762,cents:995}, {id:50808177426530,cents:1045}, {id:50808177459298,cents:1095}, {id:50808177492066,cents:1145},
    {id:50808177524834,cents:1195}, {id:50808177557602,cents:1245}, {id:50808177590370,cents:1295}, {id:50808177623138,cents:1345},
    {id:50808177655906,cents:1395}, {id:50808177688674,cents:1445}, {id:50808177721442,cents:1495}, {id:50808177754210,cents:1545},
    {id:50808177786978,cents:1595}, {id:50808177819746,cents:1645}, {id:50808177852514,cents:1695}, {id:50808177885282,cents:1745},
    {id:50808177918050,cents:1795}, {id:50808177950818,cents:1845}, {id:50808177983586,cents:1895}, {id:50808178016354,cents:1945},
    {id:50808178049122,cents:1995}, {id:50808178081890,cents:2045}, {id:50808178114658,cents:2095}, {id:50808178147426,cents:2195},
    {id:50808178180194,cents:2295}, {id:50808178212962,cents:2395}, {id:50808178245730,cents:2495}, {id:50808178278498,cents:2595},
    {id:50808178311266,cents:2695}, {id:50808178344034,cents:2795}, {id:50808178376802,cents:2895}, {id:50808178409570,cents:2995},
    {id:50808178442338,cents:3095}, {id:50808178475106,cents:3195}, {id:50808178507874,cents:3295}, {id:50808178540642,cents:3395},
    {id:50808178573410,cents:3495}, {id:50808178606178,cents:3595}, {id:50808178638946,cents:3695}, {id:50808178671714,cents:3795},
    {id:50808178704482,cents:3895}, {id:50808178737250,cents:3995}, {id:50808178770018,cents:4095}, {id:50808178802786,cents:4195},
    {id:50808178835554,cents:4295}, {id:50808178868322,cents:4395}, {id:50808178901090,cents:4495}, {id:50808178933858,cents:4595},
    {id:50808178966626,cents:4695}, {id:50808178999394,cents:4795}, {id:50808179032162,cents:4895}, {id:50808179064930,cents:4995},
    {id:50808179097698,cents:5095}, {id:50808179130466,cents:5195}, {id:50808179163234,cents:5295}, {id:50808179196002,cents:5395},
    {id:50808179228770,cents:5495}, {id:50808179261538,cents:5595}, {id:50808179294306,cents:5695}, {id:50808179327074,cents:5795},
    {id:50808179359842,cents:5895}, {id:50808179392610,cents:5995}, {id:50808179425378,cents:6095}, {id:50808179458146,cents:6195},
    {id:50808179490914,cents:6295}, {id:50808179523682,cents:6395}, {id:50808179556450,cents:6495}, {id:50808179589218,cents:6595},
    {id:50808179621986,cents:6695}, {id:50808179654754,cents:6795}, {id:50808179687522,cents:6895}, {id:50808179720290,cents:6995},
    {id:50808179753058,cents:7095}, {id:50808179785826,cents:7195}, {id:50808179818594,cents:7295}, {id:50808179851362,cents:7395},
    {id:50808179884130,cents:7495}, {id:50808179916898,cents:7595}, {id:50808179949666,cents:7695}, {id:50808179982434,cents:7795},
    {id:50808180015202,cents:7895}, {id:50808180047970,cents:7995}, {id:50808180080738,cents:8095}, {id:50808180113506,cents:8195},
    {id:50808180146274,cents:8295}, {id:50808180179042,cents:8395}, {id:50808180211810,cents:8495}, {id:50808180244578,cents:8595},
    {id:50808180277346,cents:8695}, {id:50808180310114,cents:8795}, {id:50808180342882,cents:8895}, {id:50808180375650,cents:8995},
    {id:50808180408418,cents:9095}, {id:50808180441186,cents:9195}, {id:50808180473954,cents:9295}, {id:50808180506722,cents:9395},
    {id:50808180539490,cents:9495}, {id:50808180572258,cents:9595}, {id:50808180605026,cents:9695}, {id:50808180637794,cents:9795},
    {id:50808180670562,cents:9895}, {id:50808180703330,cents:9995}, {id:50808180736098,cents:10095}
  ];
  // Earlier variants stay recognized as protection lines, so a cart that holds
  // one when this script loads is swapped to the current tier instead of doubled.
  var LEGACY_DOMESTIC_IDS = [43130589216866].concat([43130589249634, 43130589282402, 43130589315170, 43130589347938, 43130589380706, 43130589413474, 43130589446242, 43130589479010, 43130589511778, 43130589544546, 43130589577314, 43130589610082, 43130589642850, 43130589675618, 43130589708386, 43130589741154, 43130589773922, 43130589806690, 43130589839458, 43130589872226, 43130589904994, 43130589937762, 43130589970530, 43130590003298, 43130590036066, 43130590068834, 43130590101602, 43130590134370, 43130590167138, 43130590199906, 43130590232674, 43130590265442, 43130590298210, 43130590330978, 43130590363746, 43130590396514, 43130590429282, 43130590462050, 43130590494818, 43130590527586, 43130590560354, 43130590593122, 43130590625890, 43130590658658, 43130590691426, 43130590724194, 43130590756962, 43130590789730, 43130590822498, 43130590855266, 43130590888034, 43130590920802, 43130590953570, 43130590986338, 43130591019106, 43130591051874, 43130591084642, 43130591117410, 43130591150178, 43130591182946, 43130591215714, 43130591248482, 43130591281250, 43130591314018, 43130591346786, 43130591379554, 43130591412322, 43130591445090, 43130591477858, 43130591510626, 43130591543394, 43130591576162, 43130591608930, 43130591641698, 43130591674466, 43130591707234, 43130591740002, 43130591772770, 43130591805538, 43130591838306, 43130591871074, 43130591903842, 43130591936610, 43130591969378, 43130592002146, 43130592034914, 43130592067682, 43130592100450, 43130592133218, 43130592165986, 43130592198754, 43130592231522, 43130592264290, 43130592297058, 43130592329826]);

  // International protection is discontinued. These variant ids are kept only so a
  // line that already sits in a cart is recognized, removed, and never counted as merchandise.
  var HISTORICAL_INTERNATIONAL_TIER_IDS = [
    50808180768866, 50808180801634, 50808180834402, 50808180867170, 50808180899938, 50808180932706,
    50808180965474, 50808180998242, 50808181031010, 50808181063778, 50808181096546, 50808181129314,
    50808181162082, 50808181194850, 50808181227618, 50808181260386, 50808181293154, 50808181325922,
    50808181358690, 50808181391458, 50808181424226, 50808181456994, 50808181489762, 50808181522530,
    50808181555298, 50808181588066, 50808181620834, 50808181653602, 50808181686370, 50808181719138,
    50808181751906, 50808181784674, 50808181817442, 50808181850210, 50808181882978, 50808181915746,
    50808181948514, 50808181981282, 50808182014050, 50808182046818, 50808182079586, 50808182112354,
    50808182145122, 50808182177890, 50808182210658, 50808182243426, 50808182276194, 50808182308962,
    50808182341730, 50808182374498, 50808182407266, 50808182440034, 50808182472802, 50808182505570,
    50808182538338, 50808182571106, 50808182603874, 50808182636642, 50808182669410, 50808182702178,
    50808182734946, 50808182767714, 50808182800482, 50808182833250, 50808182866018, 50808182898786,
    50808182931554, 50808182964322, 50808182997090, 50808183029858, 50808183062626, 50808183095394,
    50808183128162, 50808183160930, 50808183193698, 50808183226466, 50808183259234, 50808183292002,
    50808183324770, 50808183357538, 50808183390306, 50808183423074, 50808183455842, 50808183488610,
    50808183521378, 50808183554146, 50808183586914, 50808183619682, 50808183652450, 50808183685218,
    50808183717986, 50808183750754, 50808183783522, 50809060786274, 50809060819042, 50809060851810,
    50809060884578, 50809060917346
  ];
  var LEGACY_INTERNATIONAL_IDS = [43155039780962, 43155042205794, 43155042238562, 43155042271330, 43155042304098, 43155042336866, 43155042369634, 43155042402402, 43155042435170, 43155042467938, 43155042500706, 43155042533474, 43155042566242, 43155042599010, 43155042631778, 43155042664546, 43155042697314, 43155042730082, 43155042762850, 43155042795618, 43155042828386, 43155042861154, 43155042893922, 43155042926690, 43155042959458, 43155042992226, 43155043024994, 43155043057762, 43155043090530, 43155043123298, 43155043156066, 43155043188834, 43155043221602, 43155043254370, 43155043287138, 43155043319906, 43155043352674, 43155043385442, 43155043418210, 43155043450978, 43155043483746, 43155043516514, 43155043549282, 43155043582050, 43155043614818, 43155043647586, 43155043680354, 43155043713122, 43155043745890, 43155043778658, 43155043811426, 43155043844194, 43155043876962, 43155043909730, 43155043942498, 43155043975266, 43155044008034, 43155044040802, 43155044073570, 43155044106338, 43155044139106, 43155044171874, 43155044204642, 43155044237410, 43155044270178, 43155044302946, 43155044335714, 43155044368482, 43155044401250, 43155044434018, 43155044466786, 43155044499554, 43155044532322, 43155044565090];

  // Previous US schedule, used only when PRICING_MODE is "previous" (rollback).
  // 95 consecutive variant ids on the "(US only)" product, 32768 apart.
  var PREVIOUS_CENTS = [616,641,666,691,716,741,766,791,816,841,866,891,941,966,991,1041,1066,1091,1141,1166,1191,1241,1266,1316,1341,1391,1416,1466,1491,1541,1566,1616,1666,1691,1741,1791,1816,1866,1916,1941,1991,2041,2091,2116,2166,2216,2266,2316,2341,2391,2441,2491,2541,2591,2641,2666,2716,2766,2816,2866,2916,2966,3016,3066,3116,3166,3216,3266,3316,3366,3416,3465,3515,3565,3615,3665,3715,3790,3840,3890,3940,3990,4040,4090,4141,4216,4266,4316,4366,4416,4491,4541,4591,4641,4691];
  var PREVIOUS_TIERS = PREVIOUS_CENTS.map(function (c, k) { return { id: 43130589249634 + 32768 * k, cents: c }; });
  var PREVIOUS_CEILING_CENTS = 266700;
  function previousTargetCents(v) {
    var p = v * 0.015;
    if (p < 398) p = 398;
    if (p > 4000) p = 4000;
    return Math.round(218 + p);
  }

  var ALL_VARIANT_IDS = LEGACY_DOMESTIC_IDS.concat(LEGACY_INTERNATIONAL_IDS)
    .concat(DOMESTIC_TIERS.map(function (t) { return t.id; }))
    .concat(HISTORICAL_INTERNATIONAL_TIER_IDS);

  var DECLINE_ATTRIBUTE = "package_protection_declined";

  // Shown under the line item title in cart. Edit this to change the
  // client-facing copy. Key and value both render (theme prints
  // "Key: Value"), so keep the key short.
  var LINE_ITEM_PROPERTIES = {
    "Coverage": "Protects against loss or damage in transit. Covers return shipping costs on eligible returns. Optional. You may remove this coverage before checkout."
  };

  // busy covers the whole sync chain, including the async cart writes it makes.
  // pendingResync records any cart mutation that lands while busy, so it is
  // re-evaluated once the chain finishes instead of being read mid-swap.
  var busy = false;
  var pendingResync = false;
  var lastKnownHadLine = null; // null = unknown (first run), true/false after that
  var cartWasEmpty = null; // null = unknown (first run), true/false after that
  var readdCheckTimer = null;

  function usTargetCents(v) {
    if (v <= US_KNEE_VALUE_CENTS) {
      return Math.round(US_FLOOR_CENTS + (v - MIN_OFFER_CENTS) * (US_KNEE_FEE_CENTS - US_FLOOR_CENTS) / (US_KNEE_VALUE_CENTS - MIN_OFFER_CENTS));
    }
    return Math.round(v * US_RATE + US_FIXED_CENTS);
  }

  function isUsStorefront() {
    var country = (window.EllieBelle && window.EllieBelle.country) || "US";
    return country === "US";
  }

  function getActiveProgram() {
    if (PRICING_MODE === "previous") return { tiers: PREVIOUS_TIERS, target: previousTargetCents };
    return { tiers: DOMESTIC_TIERS, target: usTargetCents };
  }

  // Merchandise value of one cart line before any discount code.
  function lineValue(item) {
    var v = typeof item.original_line_price === "number" ? item.original_line_price : item.line_price;
    return toBase(v);
  }

  // Cart prices arrive in the presentment currency. Convert to store currency
  // (USD) so thresholds and fees are always evaluated in dollars.
  function toBase(cents) {
    var rate = 1;
    try { rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) {}
    return rate === 1 ? cents : Math.round(cents / rate);
  }

  function inOfferRange(v) {
    if (!isUsStorefront()) return false;
    if (PRICING_MODE === "previous") return v > 0 && v <= PREVIOUS_CEILING_CENTS;
    return v >= MIN_OFFER_CENTS && v <= MAX_OFFER_CENTS;
  }

  function isProtectionVariant(variantId) {
    return ALL_VARIANT_IDS.indexOf(variantId) !== -1;
  }

  function findProtectionLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isProtectionVariant(cart.items[i].variant_id)) return cart.items[i];
    }
    return null;
  }

  function findProtectionLines(cart) {
    var lines = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (isProtectionVariant(cart.items[i].variant_id)) lines.push(cart.items[i]);
    }
    return lines;
  }

  // True if the line's saved properties already match LINE_ITEM_PROPERTIES.
  // Lets us catch up an existing cart line after the copy is edited, even
  // when the price tier itself hasn't changed.
  function propertiesAreCurrent(line) {
    var existing = line.properties || {};
    for (var key in LINE_ITEM_PROPERTIES) {
      if (existing[key] !== LINE_ITEM_PROPERTIES[key]) return false;
    }
    return true;
  }

  function nearestTier(tiers, targetCents) {
    var best = tiers[0];
    var bestDiff = Math.abs(tiers[0].cents - targetCents);
    for (var i = 1; i < tiers.length; i++) {
      var diff = Math.abs(tiers[i].cents - targetCents);
      if (diff < bestDiff) {
        best = tiers[i];
        bestDiff = diff;
      }
    }
    return best;
  }

  function getCart() {
    return fetch("/cart.js", { headers: { "Content-Type": "application/json" } }).then(function (r) {
      return r.json();
    });
  }

  function cartChange(payload) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json();
    });
  }

  function cartAdd(variantId) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: LINE_ITEM_PROPERTIES }]
      })
    }).then(function (r) {
      return r.json();
    });
  }

  function cartUpdateAttributes(attributes) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) {
      return r.json();
    });
  }

  // Shows or hides the "add protection back" link. Driven entirely by
  // JS rather than the Liquid template's own render of this section, so
  // it reflects the current cart state within moments of a removal
  // instead of waiting for the theme to next server-render the cart
  // drawer or cart page (which can otherwise leave it stuck out of date
  // until the client manually refreshes or reloads).
  function applyReaddVisibility(declined, hasLine, itemCount, subtotalExcl) {
    var show = declined && !hasLine && itemCount > 0 && inOfferRange(subtotalExcl);
    var wrappers = document.querySelectorAll("[data-package-protection-readd-wrapper]");
    for (var i = 0; i < wrappers.length; i++) {
      wrappers[i].hidden = !show;
    }
  }

  // Independent, read-only recheck used as a safety net for cases sync()
  // doesn't directly cover, e.g. the cart drawer's markup getting
  // (re)injected by the theme outside of the /cart/* calls this script
  // already watches. Debounced since it's driven by a MutationObserver.
  function scheduleReaddCheck() {
    if (readdCheckTimer) return;
    readdCheckTimer = setTimeout(function () {
      readdCheckTimer = null;
      getCart().then(function (cart) {
        var declined = cart.attributes && cart.attributes[DECLINE_ATTRIBUTE] === "true";
        var hasLine = !!findProtectionLine(cart);
        var subtotalExcl = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (!isProtectionVariant(item.variant_id)) subtotalExcl += lineValue(item);
        }
        applyReaddVisibility(declined, hasLine, cart.item_count, subtotalExcl);
      });
    }, 200);
  }

  function finishSync() {
    busy = false;
    if (pendingResync) {
      pendingResync = false;
      setTimeout(sync, 150);
    }
  }

  function sync() {
    if (busy) {
      pendingResync = true;
      return;
    }
    busy = true;

    getCart()
      .then(function (cart) {
        var declined = cart.attributes && cart.attributes[DECLINE_ATTRIBUTE] === "true";
        var protectionLines = findProtectionLines(cart);
        var existingLine = protectionLines.length ? protectionLines[0] : null;
        var hasLineNow = !!existingLine;

        var subtotalExcl = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (!isProtectionVariant(item.variant_id)) subtotalExcl += lineValue(item);
        }

        // Non-US storefront: protection is not offered. Remove any protection
        // line (US or historical International) and never add one. This is the
        // script's own doing, so it never sets or clears the decline flag.
        if (!isUsStorefront()) {
          lastKnownHadLine = false;
          cartWasEmpty = subtotalExcl <= 0;
          applyReaddVisibility(false, false, cart.item_count, subtotalExcl);
          if (protectionLines.length) {
            return Promise.all(protectionLines.map(function (l) {
              return cartChange({ id: l.key, quantity: 0 });
            }));
          }
          return;
        }

        // Detect a manual removal: had a line last time we checked, don't now.
        var justRemoved = lastKnownHadLine === true && !hasLineNow && subtotalExcl > 0;
        lastKnownHadLine = hasLineNow;

        // Detect a fresh start: cart was empty last time we checked (however
        // it got emptied — /cart/clear.js isn't intercepted below, so this
        // is the reliable signal) and now has real items again. A stale
        // decline flag from a previous, unrelated cart shouldn't carry over.
        var startingFresh = cartWasEmpty === true && subtotalExcl > 0 && declined;
        cartWasEmpty = subtotalExcl <= 0;

        if (startingFresh) {
          declined = false;
          cartUpdateAttributes({ package_protection_declined: "" });
        }

        if (justRemoved && !declined) {
          applyReaddVisibility(true, false, cart.item_count, subtotalExcl);
          return cartUpdateAttributes({ package_protection_declined: "true" });
        }

        // A completely empty cart (no real items) is a natural fresh-start
        // point: drop any leftover protection line and clear a stale decline
        // flag, so the next shopping session isn't permanently opted out
        // just because a prior cart was declined and then emptied.
        if (subtotalExcl <= 0) {
          applyReaddVisibility(false, false, 0, 0);
          var resetTasks = [];
          if (existingLine) {
            resetTasks.push(
              cartChange({ id: existingLine.key, quantity: 0 }).then(function () {
                lastKnownHadLine = false;
              })
            );
          }
          if (declined) {
            resetTasks.push(cartUpdateAttributes({ package_protection_declined: "" }));
          }
          if (resetTasks.length) return Promise.all(resetTasks);
          return;
        }

        // A protection line in the cart means the client has not declined it.
        // Clears a decline flag set in error (or left over from an earlier
        // race) so the fee is recalculated instead of staying frozen.
        if (declined && hasLineNow) {
          declined = false;
          return cartUpdateAttributes({ package_protection_declined: "" }).then(function () {
            pendingResync = true;
          });
        }

        if (declined) {
          applyReaddVisibility(true, hasLineNow, cart.item_count, subtotalExcl);
          return;
        }

        // Offer range: no protection below $50 or above $5,000 of merchandise
        // (excluding protection). Removing the
        // line here is the script's own doing and never sets the decline flag.
        if (!inOfferRange(subtotalExcl)) {
          applyReaddVisibility(false, hasLineNow, cart.item_count, subtotalExcl);
          if (existingLine) {
            return cartChange({ id: existingLine.key, quantity: 0 }).then(function () {
              lastKnownHadLine = false;
            });
          }
          return;
        }

        // Never more than one protection line, and never a quantity above one.
        if (protectionLines.length > 1 || (existingLine && existingLine.quantity > 1)) {
          var fixes = [];
          for (var d = 1; d < protectionLines.length; d++) {
            fixes.push(cartChange({ id: protectionLines[d].key, quantity: 0 }));
          }
          if (existingLine.quantity > 1) {
            fixes.push(cartChange({ id: existingLine.key, quantity: 1 }));
          }
          return Promise.all(fixes).then(function () {
            pendingResync = true;
          });
        }

        var program = getActiveProgram();
        var target = program.target(subtotalExcl);
        var tier = nearestTier(program.tiers, target);

        if (!existingLine) {
          applyReaddVisibility(false, true, cart.item_count, subtotalExcl);
          return cartAdd(tier.id).then(function () {
            // Not confirmed until the next read sees the line. Concurrent cart
            // writes can drop an add, and a missing line must then be re-added,
            // not mistaken for a client removing protection.
            lastKnownHadLine = false;
          });
        }

        if (existingLine.variant_id !== tier.id || !propertiesAreCurrent(existingLine)) {
          applyReaddVisibility(false, true, cart.item_count, subtotalExcl);
          return cartAdd(tier.id).then(function () {
            return cartChange({ id: existingLine.key, quantity: 0 });
          }).then(function () {
            lastKnownHadLine = false; // confirmed only by the next read
          });
        }

        applyReaddVisibility(false, true, cart.item_count, subtotalExcl);
      })
      .then(finishSync, finishSync);
  }

  // Lets a client who removed protection add it back without emptying
  // the cart. Triggered by clicking [data-package-protection-readd],
  // rendered by snippets/package-protection-readd.liquid in the cart
  // drawer and cart page when applicable. Reloads on completion so the
  // theme's own cart markup (drawer or page) reflects the new line,
  // rather than guessing at the theme's internal refresh mechanism.
  function reEnableProtection() {
    cartUpdateAttributes({ package_protection_declined: "" })
      .then(function () {
        return getCart();
      })
      .then(function (cart) {
        var existingLine = findProtectionLine(cart);
        if (existingLine) return null;

        var subtotalExcl = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (!isProtectionVariant(item.variant_id)) subtotalExcl += lineValue(item);
        }
        if (!inOfferRange(subtotalExcl)) return null;

        var program = getActiveProgram();
        var target = program.target(subtotalExcl);
        var tier = nearestTier(program.tiers, target);
        return cartAdd(tier.id);
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        window.location.reload();
      });
  }

  document.addEventListener("click", function (e) {
    var el = e.target.closest && e.target.closest("[data-package-protection-readd]");
    if (!el) return;
    e.preventDefault();
    reEnableProtection();
  });

  // Re-sync after any Ajax cart mutation, regardless of which theme
  // component (side cart, cart page, quick shop) triggered it.
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var result = nativeFetch.apply(this, arguments);
    try {
      var url = arguments[0];
      var urlStr = typeof url === "string" ? url : (url && url.url) || "";
      if (
        urlStr.indexOf("/cart/add") !== -1 ||
        urlStr.indexOf("/cart/change") !== -1 ||
        urlStr.indexOf("/cart/update") !== -1 ||
        urlStr.indexOf("/cart/clear") !== -1
      ) {
        result.then(function () {
          if (busy) {
            pendingResync = true;
          } else {
            setTimeout(sync, 150);
          }
        });
      }
    } catch (e) {}
    return result;
  };

  document.addEventListener("DOMContentLoaded", function () {
    sync();
  });

  // Safety net: catches cases where the theme injects fresh cart markup
  // (e.g. populating the drawer on open) outside of the /cart/* calls
  // intercepted above, which would otherwise leave a freshly-rendered
  // (and therefore default-hidden) readd link stuck out of sync until
  // the next cart mutation. Re-checks visibility shortly after any DOM
  // change; toggling the "hidden" attribute doesn't itself retrigger
  // this (only childList/subtree changes do), so there's no loop.
  if (window.MutationObserver && document.body) {
    new MutationObserver(function () {
      scheduleReaddCheck();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();